<style>
    @import url('https://fonts.googleapis.com/css2?family=Noto+Sans:wght@600&family=Roboto+Slab:wght@400;600;700&display=swap');
  </style>
<header>
    <mat-toolbar>
        <!-- <mat-icon>event</mat-icon> -->
        <!-- <span>Hope College Events App</span> -->
    </mat-toolbar>

    <nav class="nav">
        <ul>
            <li *ngIf="signedIn===false" class="nav-item">
                <a routerLink="/login" routerLinkActive="active" ariaCurrentWhenActive="page" class="nav-link">Login</a>
            </li>
            <li *ngIf="signedIn===true" class="nav-item">
                <a (click)="SignOut()" class="nav-link">Log Out</a>
            </li>
            <li *ngIf="signedIn===true" class="nav-item">
                <a routerLink="/homepage" routerLinkActive="active" ariaCurrentWhenActive="page" class="nav-link">Homepage</a>
            </li>
            <li *ngIf="isUser===true && signedIn===true" class="nav-item">
                <a routerLink="/edituser" routerLinkActive="active" ariaCurrentWhenActive="page" class="nav-link">Edit
                    My Account</a>
            </li>
            <li *ngIf="isOrg===true && signedIn===true" class="nav-item">
                <a routerLink="/editorg" routerLinkActive="active" ariaCurrentWhenActive="page" class="nav-link">Edit
                    Organization</a>
            </li>
        </ul>
    </nav>
</header>

<router-outlet></router-outlet>
<!-- <app-task></app-task> -->